import lodash from 'lodash'
import * as services from '@/pages/case/material/service'

const initialvalue = {
  page: {
    page_num: 1,
    page_size: 20,
  },
}

const UserModel = {
  namespace: 'materialList',

  state: {
    groupList: [],
    groupId: '',
    caseSearch: lodash.cloneDeep(initialvalue),
    caseList: [],
    caseTotal: 0,
    list: [],
  },

  subscriptions: {
    setup: ({ dispatch, history }) => {
      return history.listen(({ pathname }) => {
        if (pathname === '/bank/case/material') {
          dispatch({
            type: 'dialogList',
            payload: { ...lodash.cloneDeep(initialvalue) },
          })
        }
      })
    },
  },
  effects: {
    // 获取分组
    *fetchDepartmentList({ payload }, { call, put }) {
      const response = yield call(services.fetchDepartmentList)
      yield put({
        type: 'setState',
        payload: {groupList: response.data.groups || []},
      })
    },

    *dialogList({ payload }, { put, call, select }) {
      const res = yield call(services.dialogList, payload)

      yield put({
        type: 'setState',
        payload: {
          list: res?.data?.dialogs,
          caseTotal: res?.data?.page?.total || 0,
        },
      })
      return res
    },

    *dialogcaseSegment({ payload }, { put, call, select }) {
      const res = yield call(services.dialogcaseSegment, payload)
      return res
    },

    *dialogDetail({ payload }, { call, put }) {
      const result = yield call(services.dialogDetail, payload)
      return result
    },

    *addDialog({ payload }, { put, call, select }) {
      const res = yield call(services.addDialog, payload)
      return res
    },

    *addPortion({ payload }, { put, call, select }) {
      const res = yield call(services.addPortion, payload)
      return res
    },

    *deleteCase({ payload }, { put, call, select }) {
      const res = yield call(services.deleteCase, payload)
      return res
    },
  },
  reducers: {
    setState(state = {}, { payload }) {
      return {
        ...state,
        ...payload,
      }
    },
  },
}

export default UserModel
